import global_axios from '../../funciones_globales/interaccionapi';
import { CARGAR_MOVIMIENTOSCAJA } from './actionTypes';
import { VISUALIZAR_ALERTA, VISUALIZAR_LOADING } from '../generales/actionTypes';
import { completar_String } from '../../funciones_globales/format';

export const cargar_MovimientosCaja = (operacion=null, fechaVencDesde=null, fechaVencHasta=null) => {
	let url = '/movimientoscaja?';

	if (operacion!==null){
		url += operacion;
	}

	if (fechaVencDesde!==null){
		url += '&fechaVencDesde=' + fechaVencDesde;
	}

	if (fechaVencHasta!==null){
		url += '&fechaVencHasta=' + fechaVencHasta;
	}
	
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url,
			method: 'GET'
		})		
		.then( response => {
			let movimientosCaja = response.data;
			movimientosCaja.forEach((movCaja, i) => {
				movCaja.Nro = completar_String((i+1).toString(), '0', 3);
				movCaja.Cliente = movCaja.cli.Codigo + ' - ' + movCaja.cli.Nombre;				
				movCaja.Valor = (movCaja.Efectivo>0?movCaja.Efectivo:movCaja.Deposito);
			});
			dispatch({
				type: CARGAR_MOVIMIENTOSCAJA,
				data: movimientosCaja
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar movimientos de caja', mensaje: msgError}
			});
		});
	}
}